import React from 'react'
import styled, { keyframes } from 'styled-components'
import Box1 from '../assets/img/animated-box/animated-box-1.png'
import Box2 from '../assets/img/animated-box/animated-box-2.png'
import Box3 from '../assets/img/animated-box/animated-box-3.png'
import Box4 from '../assets/img/animated-box/animated-box-4.png'
import Box5 from '../assets/img/animated-box/animated-box-5.png'
import Box6 from '../assets/img/animated-box/animated-box-6.png'
import Box7 from '../assets/img/animated-box/animated-box-7.png'
import Colors from '../assets/styles/Colors'
import { useTranslation } from 'react-i18next'
import Responsive from '../assets/config/Responsive'
import DownloadButton from './DownloadButton'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'

const changeImages = keyframes`
  0% { background-image: url(${Box1}) }
  14.28% { background-image: url(${Box2})}
  28.56% { background-image: url(${Box3})}
  42.84% { background-image: url(${Box4})}
  57.12% { background-image: url(${Box5})}
  71.4% { background-image: url(${Box6})}
  85.68% { background-image: url(${Box7})}
  100% { background-image: url(${Box1})}
`

const CompanyCard: React.FC<{
  title: string
  imgUrl: string
  policyUrl: string
  style?: React.CSSProperties
  onClick?: () => void
}> = ({ title, imgUrl, policyUrl, style, onClick }) => {
  //
  const { t } = useTranslation()

  //
  return (
    <>
      <Wrapper style={style} $disabled={false} className="service-card">
        <ImageStyle src={imgUrl} alt="card image" />

        <Div>
          <DownloadButton
            text={t('productDetail.downloadButton')}
            style={{ width: 200, height: 40, margin: 0, padding: 0 }}
            onClick={(event) => {
              event.preventDefault()

              if (policyUrl) {
                axios({
                  url: policyUrl,
                  method: 'GET',
                  responseType: 'blob',
                  headers: {
                    'Content-Type': 'application/pdf',
                  },
                })
                  .then((response) => {
                    const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                    saveAs(pdfBlob, `${title}.pdf`)

                    onClick?.()
                  })
                  .catch((error) => {
                    toast.error('ფაილის ჩამოტვირთვისას მოხდა შეცდომა:', error)
                  })
              }
            }}
          />
        </Div>
      </Wrapper>
    </>
  )
}

// styles
const Div = styled.div`
  display: block;
  cursor: pointer;
  ${Responsive.mobile} {
    display: flex;
    margin-block: 24px;
  }
`

const AnimationBox = styled.div`
  opacity: 0;
  position: absolute;
  top: 10px;
  right: 20px;
  transition: all 300ms ease;

  width: 48px;
  height: 48px;
  background-size: contain;
  background-repeat: no-repeat;
`
const ImageStyle = styled.img`
  user-select: none;
  pointer-events: none;
  margin-bottom: 45px;
  height: 80px;
  width: 160px;
  object-fit: contain;

  ${Responsive.mobile} {
    margin-bottom: 30px;
  }
`
const InfoBlock = styled.div`
  padding-right: 40px;
  padding-left: 40px;
  user-select: none;
  pointer-events: none;
  /* h3 title */
  h3 {
    font-size: 18px;
    color: ${Colors.Black};
    text-align: center;
    text-transform: capitalize;
    margin-bottom: 28px;
  }

  /* p descirption */
  p {
    font-size: 14px;
    line-height: 22px;
    color: ${Colors.SilverChalice};
    text-align: center;
    margin-bottom: 45px;
  }

  ${Responsive.mobile} {
    padding-right: 25px;
    padding-left: 25px;
    /* h3 title */
    h3 {
      margin-bottom: 15px;
    }

    /* p descirption */
    p {
      margin-bottom: 27px;
    }
  }
`
const Wrapper = styled.div<{ $disabled: boolean }>`
  text-decoration: none;
  background-color: ${Colors.white};
  width: 100%;
  height: 100%;
  border-radius: 8px;
  padding-top: 26px;
  padding-bottom: 65px;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;

  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  ${ImageStyle} {
    opacity: ${({ $disabled }) => ($disabled ? '0.7' : '1')};
  }

  ${InfoBlock} {
    opacity: ${({ $disabled }) => ($disabled ? '0.7' : '1')};
  }

  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);

  :hover {
    ${AnimationBox} {
      opacity: 1;
      animation: ${changeImages} 600ms infinite;
    }
  }

  /* responsive */
  ${Responsive.tablet} {
    width: 350px;
  }
  ${Responsive.mobile} {
    width: 100%;
    padding-top: 20px;
    padding-bottom: 45px;
  }
`

export default CompanyCard
